import React from 'react';
import mail2 from './../../../assets/img/brand/pzu/mail2.png';
import post from './../../../assets/img/brand/pzu/post.png';
import calendar2 from './../../../assets/img/brand/pzu/calendar2.png';

const ZasadyPrzystepowania = (props) => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">
        Jak przystąpić do ubezpieczenia zdrowotnego
      </h3>
      <div className="secondColor">
        <p>
          <b>W ramach ubezpieczenia TUW PZUW</b> masz możliwość rozszerzyć
          opiekę medyczną również o pakiet <b>Senior</b>:
        </p>
        <ul>
          <li>
            Dla rodziców/teściów pracownika TVP, którzy nie ukończyli 80 r.ż.
          </li>
          <li>
            Dla rodziców/teściów współpracownika lub byłego pracownika TVP,
            którzy nie ukończyli 80 r.ż.
          </li>
          <li>
            Dla współpracowników i byłych pracowników TVP, którzy ukończyli 67
            rok życia, a nie ukończyli 80 r.ż.
          </li>
        </ul>

        <p>
          Aby objąć ubezpieczeniem rodziców/teściów wypełnij{' '}
          <b>formularz online</b>, a następnie <b>wydrukuj deklarację</b> i
          przekaż do podpisania członkom rodziny. Dla każdego członka rodziny w
          tym pakiecie konieczne jest wypełnienie odrębnej deklaracji. Pamiętaj,
          że składki za ubezpieczenie seniora opłacane są indywidualnie na
          wskazany w deklaracji numer subkonta bankowego.
        </p>

        <p>
          Aby móc zgłosić rodzica/teścia do pakietu Senior, musisz posiadać{' '}
          <b>aktywny pakiet opieki medycznej</b> jako pracownik, współpracownik
          lub były pracownik.
        </p>

        <p>
          Aby przystąpić do pakietu{' '}
          <b>Senior jako współpracownik lub były pracownik</b>, wypełnij
          formularz online, a następnie <b>wydrukuj deklarację.</b> Pamiętaj, że
          składki za ubezpieczenie seniora opłacane są indywidualnie na wskazany
          w deklaracji numer subkonta bankowego.
        </p>

        <br />
        <p>Wypełnioną i podpisaną deklarację prześlij:</p>

        <div className="container mt-4 ml-5">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={mail2} alt="mail" />
            </div>
            <div className="col-sm-11">
              w formie skanu lub zdjęcia
              <br /> na adres mailowy:{' '}
              <a href="mailto:deklaracje@datus.pl">
                <b>deklaracje@datus.pl</b>
              </a>
            </div>
          </div>
        </div>

        <div className="container mt-4 ml-5">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={post} alt="post" />
            </div>
            <div className="col-sm-11">
              lub listownie na adres:
              <br />
              <b>Datus Sp. z o.o.</b>
              <br />
              ul. Obrzeżna 7
              <br />
              02-691 Warszawa
            </div>
          </div>
        </div>

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={calendar2} alt="calendar" />
            </div>
            <div className="col-sm">
              Aby zostać objętym ubezpieczeniem zdrowotnym od{' '}
              <b>1 dnia miesiąca</b>, wypełnij, opłać i prześlij deklarację do{' '}
              <b>
                20 dnia miesiąca poprzedzającego rozpoczęcie ochrony
                ubezpieczeniowej
              </b>
              , np. jeśli wypełnisz deklarację do <b>20 listopada</b> – opieka
              medyczna rozpocznie się od <b>1 grudnia</b>; jeśli wypełnisz
              formularz pomiędzy <b>21 listopada</b> a <b>20 grudnia</b> opieka
              medyczna rozpocznie się 1 stycznia.
            </div>
          </div>
        </div>

        <br />
        <p>
          Termin opłaty składki upływa <b>20 dnia miesiąca</b> poprzedzającego
          miesiąc ochrony ubezpieczeniowej.{' '}
          <b>
            Nieopłacenie składki w terminie będzie skutkowało zakończeniem
            ubezpieczenia.
          </b>
        </p>

        <p>
          <b>Ponowne przystąpienie</b> do ubezpieczenia możliwe jest wyłącznie w{' '}
          <b>rocznicę umowy</b>, tj. <b>01.01.2027 r.</b>
        </p>
      </div>
    </React.Fragment>
  );
};

export default ZasadyPrzystepowania;
